@use '../shared-styles' as *;

@layer design-system {
  .highLowTripleLineChartRoot {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 300px;
    margin-bottom: 20px;

    [role='tooltip'] {
      z-index: var(--z-tooltip);
    }
  }

  .chart {
    width: 100%;
    min-height: 100%;
  }

  .baseLine {
    @include axis-line;
    stroke-width: 2px;
  }

  .hoverAreaRect {
    fill: transparent;
  }

  .dashedLine {
    @include axis-line;
    stroke-dasharray: 6 6;
  }
}
